interface Props {
  value: string
  label: string
  caption?: string
  checked: boolean
  hideRadio?: boolean
  onChange?: (arg: React.FormEvent<HTMLInputElement>) => void
  revealChildrenWhen: boolean
  children: React.ReactNode
}

export const ExpandingRadio: React.FC<Props> = ({
  label,
  caption,
  value,
  checked,
  onChange,
  revealChildrenWhen: reveal,
  hideRadio,
  children,
}) => (
  <div>
    <label>
      <div
        className={`expanding-radio${hideRadio ? " expanding-radio--hide" : ""}
          ${checked ? " expanding-radio--checked" : ""}
        `}
      >
        <div>
          <input
            type="radio"
            value={value}
            checked={checked}
            onChange={onChange}
          />
        </div>
        <div className="inner">
          <h4 className="expanding-radio__heading">{label}</h4>
          {caption ? (
            <p className="expanding-radio__caption">{caption}</p>
          ) : null}
          {reveal ? children : null}
        </div>
      </div>
    </label>
  </div>
)
